/* eslint-disable @typescript-eslint/no-explicit-any */
import { hall } from '@/hall'
import { ModuleBase } from './ModuleBase'
import { serverErrorMsg } from '@/defines/ServerError'
import { base } from '@/base/base'
import { MsgIDs } from '@/defines/MsgIDs'
import { wsClient } from '@/net/WebSocketClient'

export class MysticaBoxModule extends ModuleBase {
  public typeBtn = 0
  public rewardNum = 0 //奖励金额
  public rewardProp = 0 //奖励免费转次数
  public BoxType = 0 //奖励类型(1:cash,2:Spins)

  public downTime = 0 //当前倒计时时间
  public nowType = 0 //当前是哪个状态（0没有在宝箱时间。1在宝箱时间.2结束了）
  public nowIndex = 0 //当前是哪个时间段(0（都没开始）)
  public nowCloseIndex = 0 // 当前是哪个已经结束的时间段了
  //类似
  //0,1,1,2,2,3,3,4,4,5,5,6,0

  public BoxCell: any = null
  public BcanBox: any = null
  public WeeTime: any = null
  public NowTime: any = null
  public BoxNum: any = null
  public BoxTop: any = null
  public GetBox: any = null
  public time: any = null

  init(): void {
    this.BoxCell = null
    this.BcanBox = null
    this.WeeTime = null
    this.NowTime = null
    this.BoxNum = null
    this.BoxTop = null
    this.GetBox = null
  }

  onClear(): void {
    this.BoxCell = null
    this.BcanBox = null
    this.WeeTime = null
    this.NowTime = null
    this.BoxNum = null
    this.BoxTop = null
    this.GetBox = null
  }

  onLoad(): void {}

  onDestroy(): void {}

  onPreloadData(): void {}

  inits2c(): void {
    ;(hall.s2c as any)['onClientBoxActAck'] = function (msg: any) {
      //          uint32 ret = 1;
      // uint32 UserID = 2;  // 玩家ID
      // uint32 ChannelID = 3; // 渠道ID
      // bool   BcanBox = 4; // 是否能寻宝
      // uint64 WeeTime = 5;  // 当天凌晨时间(0:00:00)
      // uint64 NowTime = 6; // 当前时间
      // uint32 BoxNum = 7; // 活动寻宝次数
      // uint32 BoxTop = 8; // 活动最低参与充值金额
      // uint32 GetBox = 9; // 玩家已寻宝次数

      if (msg == null || msg.ret != 0 || msg.UserID != hall.userModule.userId) {
        base.toast(serverErrorMsg(msg.ret))
        return
      }

      hall.mysticaBoxModule.BoxCell = msg.BoxCell
      hall.mysticaBoxModule.BcanBox = msg.BcanBox
      hall.mysticaBoxModule.WeeTime = msg.WeeTime
      hall.mysticaBoxModule.NowTime = msg.NowTime
      hall.mysticaBoxModule.BoxNum = msg.BoxNum
      hall.mysticaBoxModule.BoxTop = msg.BoxTop
      hall.mysticaBoxModule.GetBox = msg.GetBox
      hall.mysticaBoxModule.makeTimeDown()
      hall.eventDispatcher.emit(hall.EventDefine.OnMysticaBoxInfo)
      hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新神秘宝箱红点
    }

    ;(hall.s2c as any)['onClientBoxActGetAck'] = function (msg: any) {
      //         uint32 ret = 1;
      // uint32 UserID = 2;	// 玩家ID
      // uint32 ChannelID = 3;
      // uint32 BoxType = 4; // 奖励类型(1:cash,2:Spins)
      // uint32 BoxProp = 5; // 金额,免费转

      if (msg == null || msg.ret != 0 || msg.UserID != hall.userModule.userId) {
        base.toast(serverErrorMsg(msg.ret))
        return
      }
      hall.mysticaBoxModule.BoxType = msg.BoxType
      if (msg.BoxType == 1) {
        hall.mysticaBoxModule.rewardNum = msg.BoxProp
      } else {
        hall.mysticaBoxModule.rewardProp = msg.BoxProp
      }
      hall.eventDispatcher.emit(hall.EventDefine.OnMysticaBoxChange)
      hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新神秘宝箱红点
    }
  }

  /// 前端请求神秘宝箱数据
  sendBoxActConfig(): void {
    const msg = {
      UserID: hall.userModule.userId,
      ChannelID: base.channelId,
    }

    wsClient.send(MsgIDs.ClientBoxActReq, msg)
  }

  // 前端请求寻宝数据
  sendBoxActGold(boxId: number): void {
    //      uint32 UserID = 1;	// 玩家ID
    // uint32 ChannelID = 2;
    // uint32 BoxCell = 3; // 格子ID

    const msg = {
      UserID: hall.userModule.userId,
      ChannelID: base.channelId,
      BoxCell: boxId,
    }

    wsClient.send(MsgIDs.ClientBoxActGetReq, msg)
  }

  makeTimeDown() {
    //设置倒计时
    //判断当前时间在哪个时间段内。不在这个时间段的话，就是可以领取时间
    //每个时间段有一个倒计时，倒计时时间到了就要重新请求时间，刷新状态
    const earlyTime = this.WeeTime + this.BoxCell[0].BoxBeginTime
    const afterTime = this.WeeTime + this.BoxCell[5].BoxEndTime
    this.nowIndex = 0
    this.nowCloseIndex = 0
    if (this.NowTime < earlyTime) {
      //时间太早了
      this.downTime = earlyTime - this.NowTime
      this.nowType = 0
    } else if (this.NowTime > afterTime) {
      //时间太晚了
      this.downTime = this.WeeTime + 86400 - this.NowTime //到凌晨12点的倒计时
      this.nowType = 2
    } else {
      //在领取时间范围内
      for (let i = 0; i < this.BoxCell.length; i++) {
        const time1 = this.WeeTime + this.BoxCell[i].BoxBeginTime
        const time2 = this.WeeTime + this.BoxCell[i].BoxEndTime
        const time3 = i == 5 ? 0 : this.WeeTime + this.BoxCell[i + 1].BoxBeginTime
        if (this.NowTime >= time1 && this.NowTime <= time2) {
          //在当前时间段
          this.nowIndex = this.BoxCell[i].CellID
          this.downTime = time2 - this.NowTime
          this.nowType = 1
          break
        } else if (i != 5 && this.NowTime < time3) {
          //不在当前时间段，但是在下一个时间段启动之前
          this.nowType = 0
          this.downTime = time3 - this.NowTime
          this.nowCloseIndex = this.BoxCell[i].CellID
          break
        }
      }
    }
  }

  isShowBoxRed() {
    return false
  }

  // 是否需要弹窗
  popupView() {
    // 增加主动弹出逻辑，每天弹出一次，在其它弹框权重后面
    // hall.popupViewModule.addPopupView(PopupViews.BindActivityPanel);
  }
}
